import { Link, useLocation } from "react-router-dom";
import { sellerService } from "../../services/enhancedCrudService";
import { useState, useEffect } from "react";

const Sidebar = () => {
  const location = useLocation();
  const [showSanitaryware, setShowSanitaryware] = useState(false);
  const [showTiles, setShowTiles] = useState(false);
  const [subscriptionStatus, setSubscriptionStatus] = useState(false);

  // Function to close sidebar on mobile
  const closeSidebar = () => {
    document.body.classList.remove('sidebar-open');
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  const fetchProfile = async () => {
    try {
      const response = await sellerService.getProfile();
      if (response.data.categories && response.data.categories.length > 0) {
        response.data.categories.find(
          (category) => category.name === "sanitaryware"
        )
          ? setShowSanitaryware(true)
          : setShowSanitaryware(false);
        response.data.categories.find((category) => category.name === "tiles")
          ? setShowTiles(true)
          : setShowTiles(false);
      }
    } catch (error) {
      console.error("Error fetching seller profile:", error);
    }
  };

  const updateSubscriptionStatus = () => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (user && user.seller_profile) {
      setSubscriptionStatus(user.seller_profile.subscription_status);
    }
  };

  useEffect(() => {
    fetchProfile();
    updateSubscriptionStatus();
    const handleStorageChange = (e) => {
      if (e.key === "user") {
        updateSubscriptionStatus();
      }
    };

    window.addEventListener("storage", handleStorageChange);
    const handleUserUpdate = () => {
      updateSubscriptionStatus();
    };

    window.addEventListener("userUpdated", handleUserUpdate);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("userUpdated", handleUserUpdate);
    };
  }, []);

  if (!subscriptionStatus) {
    return (
      <>
        <div className="sidebar">
          <div className="sidebar-header">
          <div className="sidebar-logo">
            <Link to="/subscription" onClick={closeSidebar}>
              <img
                src={"/assets/img/logo.png"}
                className="img-fluid logo1"
                alt="1"
              />
            </Link>
            <Link to="/subscription" onClick={closeSidebar}>
              <img
                src="/assets/img/logo.png"
                className="img-fluid logo-small"
                alt="2"
              />
            </Link>
          </div>
          {/* Mobile close button */}
          <button 
            className="sidebar-close-btn d-md-none" 
            onClick={() => {
              document.body.classList.remove('sidebar-open');
            }}
            style={{
              position: 'absolute',
              top: '15px',
              right: '15px',
              background: 'none',
              border: 'none',
              fontSize: '20px',
              color: '#333',
              cursor: 'pointer',
              zIndex: 1001
            }}
          >
            <i className="fas fa-times"></i>
          </button>
        </div>
          <div className="sidebar-inner">
            <div id="sidebar-menu" className="sidebar-menu">
              <ul>
                <li className="menu-title">
                  <span>Subscription Required</span>
                </li>
                <li className={isActive("/subscription") ? "active" : ""}>
                  <Link to="/subscription" onClick={closeSidebar}>
                    <i className="fe fe-credit-card text-white"></i>{" "}
                    <span>Subscribe Now</span>
                  </Link>
                </li>
                <li className="menu-title">
                  <span>Legal</span>
                </li>
                <li
                  className={isActive("/legal/terms-privacy") ? "active" : ""}
                >
                  <Link to="/legal/terms-privacy" onClick={closeSidebar}>
                    <i className="fe fe-file-text text-white"></i>{" "}
                    <span>Terms & Privacy</span>
                  </Link>
                </li>
                <li className={isActive("/legal/help") ? "active" : ""}>
                  <Link to="/legal/help" onClick={closeSidebar}>
                    <i className="fe fe-help-circle text-white"></i>{" "}
                    <span>Help</span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          {/* KodeAccel Logo at bottom */}
          <div className="sidebar-footer" style={{
            position: 'absolute',
            bottom: '20px',
            left: '50%',
            transform: 'translateX(-50%)',
            textAlign: 'center',
            width: '100%',
            padding: '0 20px'
          }}>
            <a 
              href="https://kodeaccel.com" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{
                display: 'inline-block',
                textDecoration: 'none'
              }}
            >
              <img 
                src="/assets/img/kodeaccel-logo.svg" 
                alt="Tech powered By kodeaccel" 
                style={{
                  maxWidth: '150px',
                  height: 'auto',
                  opacity: '0.8',
                  transition: 'opacity 0.3s ease'
                }}
                onMouseEnter={(e) => e.target.style.opacity = '1'}
                onMouseLeave={(e) => e.target.style.opacity = '0.8'}
              />
            </a>
          </div>
        </div>
      </>
    );
  }
  return (
    <>
      <div className="sidebar">
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <Link to="/sellers/profile" onClick={closeSidebar}>
              <img
                src={"/assets/img/logo.png"}
                className="img-fluid logo1"
                alt="1"
              />
            </Link>
            <Link to="/sellers/profile" onClick={closeSidebar}>
              <img
                src="/assets/img/logo.png"
                className="img-fluid logo-small"
                alt="2"
              />
            </Link>
          </div>
          {/* Mobile close button */}
          <button 
            className="sidebar-close-btn d-md-none" 
            onClick={() => {
              document.body.classList.remove('sidebar-open');
            }}
            style={{
              position: 'absolute',
              top: '15px',
              right: '15px',
              background: 'none',
              border: 'none',
              fontSize: '20px',
              color: '#333',
              cursor: 'pointer',
              zIndex: 1001
            }}
          >
            <i className="fas fa-times"></i>
          </button>
        </div>
        <div className="sidebar-inner">
          <div id="sidebar-menu" className="sidebar-menu">
            <ul>
              {/* <li className={isActive("/dashboard") ? "active" : ""}>
                <Link to="/dashboard">
                  <i className="fe fe-home text-white"></i>{" "}
                  <span>Dashboard</span>
                </Link>
              </li> */}
              <li className="menu-title">
                <span>Account Management</span>
              </li>
              <li className={isActive("/sellers/profile") ? "active" : ""}>
                <Link to="/sellers/profile" onClick={closeSidebar}>
                  <i className="fe fe-user text-white"></i> <span>Profile</span>
                </Link>
              </li>
              <li className={isActive("/sellers/reviews") ? "active" : ""}>
                <Link to="/sellers/reviews" onClick={closeSidebar}>
                  <i className="fe fe-star text-white"></i> <span>Reviews</span>
                </Link>
              </li>
              <li className={isActive("/accounts/change-pin") ? "active" : ""}>
                <Link to="/accounts/change-pin" onClick={closeSidebar}>
                  <i className="fe fe-lock text-white"></i>{" "}
                  <span>Change PIN</span>
                </Link>
              </li>
              <li className={isActive("/invoice") ? "active" : ""}>
                <Link to="/invoice" onClick={closeSidebar}>
                  <i className="fe fe-file-text text-white"></i>{" "}
                  <span>Invoice</span>
                </Link>
              </li>
              <li className="menu-title">
                <span>Subscription</span>
              </li>
              <li
                className={
                  isActive("/subscription/my-subscription") ? "active" : ""
                }
              >
                <Link to="/subscription/my-subscription" onClick={closeSidebar}>
                  <i className="fe fe-user-check text-white"></i>{" "}
                  <span>My Subscription</span>
                </Link>
              </li>
              {!subscriptionStatus && (
                <li className={isActive("/subscription") ? "active" : ""}>
                  <Link to="/subscription" onClick={closeSidebar}>
                    <i className="fe fe-credit-card text-white"></i>{" "}
                    <span>Plans</span>
                  </Link>
                </li>
              )}
              <li className="menu-title">
                <span>Product Management</span>
              </li>
              {showSanitaryware && (
                <li
                  className={isActive("/products/sanitaryware") ? "active" : ""}
                >
                  <Link to="/products/sanitaryware" onClick={closeSidebar}>
                    <i className="fe fe-droplet text-white"></i>{" "}
                    <span>Upload Sanitary Ware Stock</span>
                  </Link>
                </li>
              )}
              {showTiles && (
                <li className={isActive("/products/tiles") ? "active" : ""}>
                  <Link to="/products/tiles" onClick={closeSidebar}>
                    <i className="fe fe-grid text-white"></i> <span>Upload Tiles Stock</span>
                  </Link>
                </li>
              )}
              <li className={isActive("/sellers/catalogs") ? "active" : ""}>
                <Link to="/sellers/catalogs" onClick={closeSidebar}>
                  <i className="fe fe-book-open text-white"></i>{" "}
                  <span>Upload Regular Design Catalogs</span>
                </Link>
              </li>
              <li className={isActive("/social/posts") ? "active" : ""}>
                <Link to="/social/posts" onClick={closeSidebar}>
                  <i className="fe fe-share-2 text-white"></i>{" "}
                  <span>Posts</span>
                </Link>
              </li>

              {/* <li className="menu-title">
                <span>Inquiry Management</span>
              </li>
              {showTiles && (
                <li className={isActive("/sellers/tile-inquiry-click-list") ? "active" : ""}>
                  <Link to="/sellers/tile-inquiry-click-list" onClick={closeSidebar}>
                    <i className="fe fe-bar-chart-2 text-white"></i>{" "}
                    <span>Tile Inquiry Clicks</span>
                  </Link>
                </li>
              )}
              {showSanitaryware && (
                <li className={isActive("/sellers/sanitaryware-inquiry-click-list") ? "active" : ""}>
                  <Link to="/sellers/sanitaryware-inquiry-click-list" onClick={closeSidebar}>
                    <i className="fe fe-droplet text-white"></i>{" "}
                    <span>Sanitaryware Inquiry Clicks</span>
                  </Link>
                </li>
              )} */}

              <li className="menu-title">
                <span>Legal</span>
              </li>
              <li className={isActive("/legal/terms-privacy") ? "active" : ""}>
                <Link to="/legal/terms-privacy" onClick={closeSidebar}>
                  <i className="fe fe-file-text text-white"></i>{" "}
                  <span>Terms & Privacy</span>
                </Link>
              </li>
              <li className={isActive("/legal/help") ? "active" : ""}>
                <Link to="/legal/help" onClick={closeSidebar}>
                  <i className="fe fe-help-circle text-white"></i>{" "}
                  <span>Help</span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
        {/* KodeAccel Logo at bottom */}
        {/* <div className="sidebar-footer" style={{
          position: 'absolute',
          bottom: '-4px',
          left: '50%',
          transform: 'translateX(-50%)',
          textAlign: 'center',
          width: '100%',
          padding: '0 20px'
        }}>
          <a 
            href="https://kodeaccel.com" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              textDecoration: 'none'
            }}
          >
            <img 
              src="/assets/img/kodeaccel-logo.svg" 
              alt="Tech powered By kodeaccel" 
              style={{
                maxWidth: '150px',
                height: 'auto',
                opacity: '0.8',
                transition: 'opacity 0.3s ease'
              }}
              onMouseEnter={(e) => e.target.style.opacity = '1'}
              onMouseLeave={(e) => e.target.style.opacity = '0.8'}
            />
          </a>
        </div> */}
      </div>
    </>
  );
};

export default Sidebar;
